import React from 'react'
import { AuthContainer } from './components'
import { useAuthFlow, useCanvaIntegration } from './hooks'

export default function Authentication() {
  // If Canva has brought up this page on connecting a Canva user to the Kinstak Canva app,
  // check that the user's Kinstak record is synced with their Canva ID,
  // and redirect with a "success" URL if they are synced,
  // allowing Canva to return the user to the Canva site.
  // If the Kinstak user is not synced with Canva, or there is no Kinstak user in local storage,
  // the login page will be brought up.

  // Initialize authentication hooks for flow management and Canva integration
  useAuthFlow() // Handles Hub.listen events and post-auth navigation
  useCanvaIntegration() // Handles Canva user sync and parameter processing

  return <AuthContainer />
}
